import React from 'react';
import { compose, is, pipe } from 'ramda';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import styleFile from './ServiceHotelAvail.js';

import { checkSameProps } from '@synergycms_core/utils';
import { getSegmentsFilled, addScripts } from '../../utils';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { filterAvailServices, filterUnavailableServices } from '../../store/avail/availServicesActions';
import {
  filterSelection,
  validateFormat,
  validateQuota,
  addToBlocks,
  SELECTION_ERROR_NOT_FOUND,
  SELECTION_ERROR_INVALID_FORMAT,
  SELECTION_ERROR_NOT_AVAILABLE
} from '../../utils/services';
import { Loading } from '@synergycms_core/components/functional/Loading';
import Footer from '../../components/functional/Footer/Footer.jsx';
//import SearchOptions from '../../components/functional/SearchOptions';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import actions from '../../store/actions';
import { AvailServiceHeader } from '../../components/functional/AvailServiceHeader';
import { AvailServiceDetail } from '../../components/functional/AvailServiceDetail';
import { AvailServiceFooter } from '../../components/functional/AvailServiceFooter';
import { AvailMainSideSummary } from '../../components/functional/AvailMainSideSummary';
import LoyaltySummaryBanner from '../../components/functional/Loyalty/LoyaltySummaryBanner.jsx';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';
import moment from 'moment';
import { SERVICE_PER_NIGHT_TYPES } from '../../config/constants.js';

const { step: stepActions } = actions.customer;

// GLOSARIO.md FCL-002 — mensajes de notificación según la categoría de error del pipeline.
const SELECTION_ERROR_MESSAGES = {
  [SELECTION_ERROR_NOT_FOUND]: '_%uno de los servicios seleccionados no existe%_',
  [SELECTION_ERROR_INVALID_FORMAT]: '_%uno de los servicios seleccionados tiene un formato incorrecto, seleccione manualmente los servicios que desee%_',
  [SELECTION_ERROR_NOT_AVAILABLE]: '_%uno de los servicios seleccionados no está disponible para la fecha seleccionada%_'
};
const SELECTION_ERROR_GENERIC = '_%ha habido errores en la selección de servicios, por favor revise la selección y termine de seleccionar los necesarios%_';

const getSelectionErrorMessage = (errors) =>
  errors.length === 1 ? SELECTION_ERROR_MESSAGES[errors[0]] : SELECTION_ERROR_GENERIC;

const ServiceHotelAvail = class ServiceHotelAvail extends React.Component {
  static displayName = 'ServiceHotelAvail';

  services = new List();
  routerUpdating = false;

  selectionAvailApplied = false;
  selectionAvailFullSuccess = false;

  constructor(props) {
    super(props);
    const { availServices, roomRatesSelected, hotel, referer } = this.props;
    const scripts = hotel.getIn(['extended_scripts'], undefined);
    
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotel, referer, 'service');
    }

    this.services =
      availServices &&
      availServices.get('success') === true &&
      filterAvailServices(availServices.get('services'), roomRatesSelected);
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    return checkSameProps(this.props, nextProps, Object.keys(this.props)) || this.state !== nextState;
  };

  // GLOSARIO.md FCL-002 — preselección de servicios vía selection_avail
  addSelectionAvailServices = () => {
    const { selectionAvail, availServices, roomRatesSelected, checkin, numberOfNights, addService, addServiceByTime } = this.props;

    return pipe(
      filterSelection(availServices),
      validateFormat(availServices),
      validateQuota(availServices, roomRatesSelected),
      addToBlocks(availServices, roomRatesSelected, checkin, numberOfNights, {
          addService,
          addServiceByTime
      })
    )({ selection: selectionAvail, fullSuccess: true });
  }

  checkRoomRates = () => {
    this.goForward = this.props.goForward.bind(this);
    this.goBack = this.props.goBack.bind(this);

    const { roomRatesSelected, segmentsFilled, selectionAvail, skipServiceStep } = this.props;

    // Si no hi han habitacions seleccionades tirem enrere
    if (
      !roomRatesSelected ||
      !is(List, roomRatesSelected) ||
      segmentsFilled === 0 ||
      segmentsFilled !== roomRatesSelected.size
    ) {
      this.routerUpdating = true;
      this.goBack();
    }

    const hasNoServices = !this.services || !is(List, this.services) || this.services.size === 0;

    if (selectionAvail && !this.selectionAvailApplied) {
      this.selectionAvailApplied = true;
      const result = this.addSelectionAvailServices();
      this.selectionAvailFullSuccess = result.fullSuccess;
      if (result.errors && result.errors.length) {
        this.props.showErrorNotification(getSelectionErrorMessage(result.errors));
      }
    }

    const hasValidSelectionAvail = this.selectionAvailApplied ? this.selectionAvailFullSuccess : false;

    /* Si tenemos filtrado de selección de dispo y además nos viene el param de force_step con valor 3 (customerForm),
    nos saltaremos el step de servicios aunque haya servicios disponibles */
    const forceCustomerForm = hasValidSelectionAvail ? skipServiceStep : false;

    // Si no queden serveis per mostrar anem al formulari directament o si ens han forçat a anar al pas 3
    if (!this.routerUpdating && (hasNoServices || forceCustomerForm)) {
      this.goForward();
    }
  };

  isMobile = () => this.props.theme.uaDeviceType !== 'DESK';

  render() {
    this.checkRoomRates();
    const { classes } = this.props.theme.styles;
    const { hasPendingSelection } = this.props;

    return (
      !this.routerUpdating &&
      this.services && (
        <div className={classes.defaultStyle}>
          <LoyaltyUserPoints/>
          {/*<SearchOptions innerStyle={'monoHotelSearchOptions'}/>*/}
          <div className={classes.mainContainer}>
            <div className={[classes.serviceContainer, classes.notBaseReset].join('')}>
              {!this.isMobile() && 
                <AvailServiceHeader 
                  onNextClick={this.props.onNextClick.bind(this)} 
                  disableNextStepButton={hasPendingSelection}/>
              }
              <ul>
                {this.services.map((service, key) => {
                  return (
                    <li key={key}>
                      <AvailServiceDetail service={service}/>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className={classes.summaryContainer}>
              <AvailMainSideSummary/>
              <LoyaltySummaryBanner/>
            </div>
            {this.props.theme.width < 901 &&
              <LoyaltySummaryBanner/>
            }
          </div>
          <Footer />
          <AvailServiceFooter
            onNextClick={this.props.onNextClick.bind(this)}
            disableNextStepButton={hasPendingSelection}/>
        </div>
      )
    );
  }
};

const cleanUpSelectionAvailParams = (dispatch) => {
  dispatch(actions.customer.params.updateParams(Map({ selection_avail: null, forced_step: null })));
  dispatch(actions.customer.selectionAvail.set(false));
  dispatch(actions.customer.forcedStep.set(false));
  dispatch(actions.customer.step.jumpSteps.clear());
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    goForward: () => {
      dispatch(stepActions.change('customerForm'));
      dispatch(actions.customer.reservation.postAsync()).then(() => {
        cleanUpSelectionAvailParams(dispatch);
        dispatch(actions.router.update());
      }).catch((e) => {
        if (e.name === 409) {
          dispatch(actions.avail.resetAvail());
          dispatch(actions.availServices.resetAvail());
        }
        dispatch(stepActions.change('monoHotelAvail'));
        dispatch(actions.router.update(true));
      });
    },
    goBack: () => {
      cleanUpSelectionAvailParams(dispatch);
      dispatch(stepActions.change('monoHotelAvail'));
      dispatch(actions.router.update());
    },
    resetSelectionAvail: () => {
      cleanUpSelectionAvailParams(dispatch);
      dispatch(actions.customer.step.jumpSteps.clear());
    },
    onNextClick: () => e => {
      e.preventDefault();
      dispatch(actions.events.trigger('next_step_2'));
      dispatch(actions.customer.step.next());
      dispatch(actions.customer.header.show('engine', false));
      dispatch(actions.customer.reservation.postAsync()).then(() => {
        cleanUpSelectionAvailParams(dispatch);
        dispatch(actions.router.update());
      }).catch((e) => {
        if (e.name === 409) {
          dispatch(actions.avail.resetAvail());
          dispatch(actions.availServices.resetAvail());
        }
        dispatch(stepActions.change('monoHotelAvail'));
        dispatch(actions.router.update(true));
      });
    },

    showErrorNotification: text => {
      dispatch(actions.notifications.send('error', text));
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    },


    addService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addService(serviceBlocks));
    },
    addServiceByTime: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addServiceByTime(serviceBlocks));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  let availServices = store.getIn([
    'availServices',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
    'response'
  ]);

  const reservationRequest = store.getIn(['customer', 'reservation_request']);



  // Filtramos los servicios por noche que no cumplen el criteria del cliente
  if(availServices && availServices.get('success') !== false) {
    availServices = availServices.set(
      'services', 
      filterUnavailableServices(
        availServices.get('services'), 
        reservationRequest
      )
    );
  }

  let hasPendingSelection = false;

  const checkin = reservationRequest.get('checkin');
  const checkout = reservationRequest.get('checkout');
  const numberOfNights = moment(checkout).diff(moment(checkin), 'days');

  // Comprobamos si de los servicios que tiene seleccionados el cliente hay algun pendiente de seleccion (por noche con cupo por horas)
  if (reservationRequest.get('blocks', List()).size > 0) {
    const blocks = reservationRequest.get('blocks', List());

    blocks.forEach((block) => {
      const blockServices = block.get('services', List());
      
      blockServices.forEach((blockService) => {
        const blockServiceId = blockService.get('service_id');
        const blockServiceSelected = availServices
          .get('services')
          .find((service) => service.get('id') === blockServiceId);

        if(blockServiceSelected) {
          const blockServiceType = blockServiceSelected.get('type', '').toUpperCase();

          const isNightService = SERVICE_PER_NIGHT_TYPES.includes(blockServiceType);
          const worksWithQuotaHours = blockServiceSelected.get('works_with_quota', false) && blockServiceSelected.get('works_with_quota_time', false);
          const daysSize = blockService.get('dates', List()).size;

          if(isNightService && worksWithQuotaHours && daysSize < numberOfNights) {
            hasPendingSelection = true;
          }
        }
      });

    });
  }

  const roomRatesSelected = store.getIn(['customer', 'reservation_request', 'blocks']);
  const jumpSteps = store.getIn(['customer', 'step', 'jump_steps'], List());
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code'], null);

  return {
    roomRatesSelected: roomRatesSelected,
    availServices: availServices,
    segmentsFilled: roomRatesSelected ? getSegmentsFilled(roomRatesSelected) : 0,
    selectionAvail: store.getIn(['customer', 'selection_avail'], null),
    hotel: store.getIn(['hotels', hotelId]),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], false),
    hasPendingSelection: hasPendingSelection,
    skipServiceStep: jumpSteps && jumpSteps?.includes(stepCode), //GLOSARIO.md - FCL-001
    checkin: checkin,
    numberOfNights: numberOfNights
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    onNextClick: dispatchProps.onNextClick(ownProps)
  });
};

// TODO agafar tradu d'on toca
const fragment = (
  <React.Fragment>
    <Loading
      richText={{
        ucFirst: true,
        style: ['descriptionText'],
        text: '_%estamos buscando los mejores precios para ti%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  PropertyManager([
    'onNextClick', 
    'hasPendingSelection',
    'addService',
    'addServiceByTime',
    'showErrorNotification'
  ]),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  withThemeJSS({ styleFile, index: 200, link: true })
)(ServiceHotelAvail);
